import React, {useCallback, useEffect} from 'react';
import styled from 'styled-components';
import {shallowEqual, useDispatch, useSelector} from 'react-redux';
import UGCRnR from '../../../../stories/components/hotels/DetailsPage/UGCRnR/UGCRnR';
import RnRLoader from '../../../../stories/components/hotels/Loadingpage/RnR/RnRAllcomponent/RnRAllcomponent';

// CONFIG
import {detailsNavigationIds} from '@stencil/hotels-utils/src/get-details-navigation-id-and-values';
import {DEFAULT_RNR_SORTBY} from '@stencil/hotels-ugc-redux/src/ugc-config';

//Selectors
import {
  hasReviewDataSelector,
  hasDataSelector,
  reviewDetailTypeSelector,
  pendingReviewDataSelector,
  snapDataSelector,
} from '@stencil/hotels-ugc-redux/src/hotels-ugc-selectors';
import {hotelIdSelectorFnFromDetails} from '@stencil/hotels-details-reducer/src/selectors';

import {selectedPropertyReviewType} from '@stencil/hotels-common-reducer/src/selectors';

// Actions
import {
  updateSelectedRnrType,
  userReviewDetailType,
} from '@stencil/hotels-ugc-redux/src/hotels-ugc-actions';

//Thunks
import {fetchSnapData, fetchUserReviews} from '@stencil/hotels-ugc-redux/src/hotels-ugc-thunks';

const RnRStyledWrapper = styled.div(
  props => `
  margin: 0 0 ${props.theme.spacing.xxlarge} 0
`,
);

const RNR = () => {
  // Getting data from selectors
  const hasReviewData = useSelector(hasReviewDataSelector, shallowEqual);
  const hasData = useSelector(hasDataSelector, shallowEqual);
  const reviewDetailType = useSelector(reviewDetailTypeSelector, shallowEqual);
  const pendingReviewData = useSelector(pendingReviewDataSelector, shallowEqual);
  const snapData = useSelector(snapDataSelector, shallowEqual);
  const hotelId = useSelector(hotelIdSelectorFnFromDetails);
  const reviewTypeFromSRP = useSelector(selectedPropertyReviewType);

  const dispatch = useDispatch();

  const {giDataExists = true, taDataExists, ugcSrc = ''} = snapData;

  const updateSnapData = useCallback(
    id => {
      return dispatch(fetchSnapData(id));
    },
    [hasData],
  );

  const updateReviewDetail = useCallback(
    detailType => {
      return dispatch(userReviewDetailType(detailType));
    },
    [reviewDetailType],
  );

  const updateSelectedTab = useCallback(
    name => {
      return dispatch(updateSelectedRnrType(name));
    },
    [dispatch],
  );

  const updateReviewData = useCallback(
    (vid, offset, lim, tags, filter, sortBy) => {
      return dispatch(fetchUserReviews(vid, offset, lim, tags, filter, sortBy));
    },
    [hasReviewData],
  );

  useEffect(() => {
    hotelId && updateSnapData(hotelId);
  }, [hotelId]);

  const {offset = 0, limit = 5} =
    reviewDetailType.page === 1 ? {} : {offset: 5 + (reviewDetailType.page - 2) * 25, limit: 25};

  useEffect(() => {
    if (giDataExists && taDataExists) {
      hotelId && updateReviewData(hotelId, offset, limit, [], '', DEFAULT_RNR_SORTBY);
      updateReviewDetail({
        offset: offset,
        limit: limit,
        tagIds: [],
        filter: '',
        sortBy: DEFAULT_RNR_SORTBY,
      });
    } else if (giDataExists && !taDataExists) {
      hotelId && updateReviewData(hotelId, offset, limit, [], '', DEFAULT_RNR_SORTBY);
      updateReviewDetail({
        offset: offset,
        limit: limit,
        tagIds: [],
        filter: '',
        sortBy: DEFAULT_RNR_SORTBY,
      });
    }

    let typeOfreview = reviewTypeFromSRP ? reviewTypeFromSRP : ugcSrc;
    typeOfreview && updateSelectedTab(typeOfreview);
  }, [snapData, reviewTypeFromSRP]);

  if (pendingReviewData) {
    return (
      <RnRStyledWrapper id={detailsNavigationIds.guestReviews} data-testid="rnrComponentLoader">
        <RnRLoader />
      </RnRStyledWrapper>
    );
  }

  if (!(giDataExists || taDataExists)) {
    return null;
  }

  return (
    <RnRStyledWrapper id={detailsNavigationIds.guestReviews} data-testid="rnrComponent">
      <UGCRnR />
    </RnRStyledWrapper>
  );
};

export default RNR;
